import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, ChangeDetectionStrategy} from '@angular/core';
import { Tender } from '../../../../models/tender';
import { Contract } from '../../../../models/contract';
import { Round } from '../../../../models';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import {ROUND_STATUSES} from "../../../../models/round";
import { User } from "../../../../../auth/models";
import {ToastService} from "../../../../../main/services/toast";
import { filter } from 'rxjs/operators';
@Component({
    selector: 'jft-round-controls',
    templateUrl: './round-controls.component.html',
    styleUrls: ['./round-controls.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RoundControlsComponent implements OnInit, OnDestroy {

    @Input()
    public tender: Tender;

    @Input()
    public contract: Contract;

    @Input()
    public round: Round = null;

    @Input()
    public rounds: Round[] = null;

    @Input()
    public isSubmittedBid: boolean = false;

    @Input()
    public suppliersCount = 0;

    @Output()
    private onRoundChange = new EventEmitter();

    public isDashboardPage: boolean;
    public isAnalysisPage: boolean;
    public roundStatuses = ROUND_STATUSES;

    private routerSubscription: Subscription;

    constructor(
        public user: User,
        private router: Router,
        protected toast: ToastService,) {
    }

    public ngOnInit() {
        this.round = this.round ? this.round : this.contract.currentRound;

      this.routerSubscription = this.router.events.pipe(filter((event) => {
        return event instanceof NavigationEnd;
      })).subscribe((event: NavigationEnd) => {
            this.setIsDashboardPage(event.url);
            this.setIsAnalysisPage(event.url);
        });

        this.setIsDashboardPage(this.router.url);
        this.setIsAnalysisPage(this.router.url);
    }

    public isCurrentRound() {
        return this.round && this.round.round == this.contract.currentRound.round;
    }

    private setIsDashboardPage(url: string) {
        this.isDashboardPage = url.endsWith('/dashboard');
    }

    private setIsAnalysisPage(url: string) {
        this.isAnalysisPage = url.endsWith('/analysis');
    }

    public ngOnDestroy(): void {
        this.routerSubscription.unsubscribe();
    }

    public changeRound(event) {
        this.onRoundChange.next(event);
    }

    public onRoundExtend(round: Round) {
        this.round = round;
        this.toast.success(`Round has been extended`);
    }
}
